<template>
  <div class="load-file-small">
    <button class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored">
      <i class="material-icons">unarchive</i>{{ i18n().load }}
    </button>
    <input class="hidden-file" type="file" v-on:change="handleInputChange">
  </div>
</template>

<script>
  import i18n from "i18n"
  import { dropZoneState } from "./GlobalDropZone.js";

  export default {
    name: 'load-file-small',
    data () {
      return {
      }
    },
    methods: {
      i18n() { return i18n().loadFile },
      handleInputChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.handleFileSelected(files[0])
      },
      handleFileSelected(file) {
        this.$emit('file', file)
      }
    },
    mounted() {
      dropZoneState.dropReceiver = (files) => this.handleFileSelected(files[0])
    },
    beforeDestroy() {
      dropZoneState.dropReceiver = null
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .load-file-small {
    display: inline-block;
    position: relative;
    margin: 0.23em;
  }
  .load-file-small button {
    position: relative;
    display: inline-block;

    float: right;
    max-width: 7em;
    padding-left: 0.66em;
    padding-right: 0.66em;
  }

  .load-file-small input.hidden-file {
    border: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom:0;
    width: 100%;
    height: 100%;
    pointer-events: all;
    cursor: pointer;
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// LoadFileSmall.vue?56bd6c09